/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_DateInputs */

const en_select_date = /** @type {(inputs: Select_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select date`)
};

const es_select_date = /** @type {(inputs: Select_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona fecha`)
};

/**
* | output |
* | --- |
* | "Select date" |
*
* @param {Select_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_date = /** @type {((inputs?: Select_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_date(inputs)
	return es_select_date(inputs)
});